import Datasheet from 'react-datasheet';

export class UsersDatasheet extends Datasheet<GridElement, string | number> {}

export type GridElement = Datasheet.Cell<GridElement, string | number> & {
  value: string | number | null;
};

export type Selection = {
  start: { i: number; j: number };
  end: { i: number; j: number };
};
